import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "gw-details",
  "use": "gw-details-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"gw-details\"><path fill=\"none\" d=\"M0 0h24v24H0Z\" /><path d=\"m3.84 5.49 7.29 12.96c.38.68 1.36.68 1.74 0l7.29-12.96A.998.998 0 0 0 19.29 4H4.71c-.76 0-1.25.82-.87 1.49ZM6.38 6h11.25L12 16 6.38 6Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol